import { PARTICIPANT_SUBTITLE_SEPARATOR } from './constants'

import type { TFunction } from 'i18next'

export const getParticipantSubtitle = (
  labels: string[],
  jobTitle: string,
  t: TFunction
) => {
  const subtitleParts = labels.map((label) => {
    switch (label.toLowerCase()) {
      case 'whitelist':
        return t('Chat.Sidebar.Participants.Whitelisted')
      case 'blacklist':
        return t('Chat.Sidebar.Participants.Blacklisted')
      default:
        return label
    }
  })

  if (jobTitle) subtitleParts.push(jobTitle)

  return subtitleParts.join(PARTICIPANT_SUBTITLE_SEPARATOR)
}